import { SVLoader, SVListPagination, SVTable } from '@/components/core';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import { useGetLendingList } from '@/hooks/requests/useLending';
import { SVTableRow } from '@/types/common';
import { titleCase } from '@/utils/stringCaser';
import { Card, Stack } from '@mui/material';

export default function LendingList() {
  const { loanRequests, isLoanRequestsPending, totalRecordCount } =
    useGetLendingList();

  const rows: SVTableRow[] = loanRequests.map(loanRequest => {
    const { uuid, loanProduct, loanType, submittedAt } = loanRequest;

    return {
      key: uuid,
      cells: [
        {
          key: `${uuid}-product`,
          content: titleCase(loanProduct),
          type: 'text',
        },
        {
          key: `${uuid}-type`,
          content: titleCase(loanType),
          type: 'text',
        },
        {
          key: `${uuid}-submitted`,
          content: submittedAt,
          type: 'date',
        },
        {
          key: `${uuid}-manage`,
          content: uuid,
          type: 'link',
        },
      ],
    };
  });

  return (
    <DefaultLayout
      header={`Lending Requests ${totalRecordCount ? `(${totalRecordCount})` : ''}`}>
      {isLoanRequestsPending ? (
        <SVLoader />
      ) : (
        <Stack spacing={2}>
          <Card>
            <SVTable
              ariaLabel="Lending Requests List"
              headers={[
                { key: 'product', content: 'Loan Product' },
                { key: 'type', content: 'Loan Type' },
                { key: 'submitted', content: 'Submitted At' },
                { key: 'details', content: '' },
              ]}
              rows={rows}
            />
          </Card>
          <SVListPagination totalRecordCount={totalRecordCount} />
        </Stack>
      )}
    </DefaultLayout>
  );
}
